import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RequestResponse } from '../model/dto/RequestResponse';
import { TransferStore } from '../model/TransferStore';
import { TransferStoreEntry } from '../model/TransferStoreEntry';
import { TransferStoreEntryDetail } from '../model/TransferStoreEntryDetail';
import { DatePipe } from '@angular/common';

@Injectable()
export class TransferStoreFacade {
    private _urlBase: string;
    private _httpClient: HttpClient;
    private _datePipe: DatePipe;

    constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string, datePipe: DatePipe) {
        this._urlBase = baseUrl;
        this._httpClient = http;
        this._datePipe = datePipe;
    }

    GetAllTransferStore(startDate: Date, endDate: Date, organizationId: string): Observable<RequestResponse<TransferStore[]>> {
        let startDateJson = this._datePipe.transform(startDate, 'yyyy-MM-dd', 'local');
        let endDateJson = this._datePipe.transform(endDate, 'yyyy-MM-dd', 'local');
        return this._httpClient.get<RequestResponse<TransferStore[]>>(this._urlBase + 'api/TransferStore/All?startDate='+startDateJson+'&endDate='+endDateJson+'&organizationId='+organizationId);
    }

    GetCollectionTransferStoreByDates(organizations: string, startDate: string, endDate: string, language: number): Observable<RequestResponse<TransferStore[]>> {
        return this._httpClient.get<RequestResponse<TransferStore[]>>(this._urlBase + 'api/TransferStore/ByDates?organizations='
         + organizations + '&startDate=' + startDate + '&endDate=' + endDate + '&language=' + language);
    }

    GetTransferStoreDetail(transferStoreId): Observable<RequestResponse<TransferStore>> {
        return this._httpClient.get<RequestResponse<TransferStore>>(this._urlBase
            + 'api/TransferStore/Detail?transferStoreId=' + transferStoreId);
    }

    GetTransferStoreEntry(transferStoreId): Observable<RequestResponse<TransferStoreEntry[]>> {
        return this._httpClient.get<RequestResponse<TransferStoreEntry[]>>(this._urlBase
            + 'api/TransferEntryStore?transferStoreId=' + transferStoreId);
    }

    GetTransferStoreEntryDetail(transferEntryStoreId): Observable<RequestResponse<TransferStoreEntryDetail[]>> {
        return this._httpClient.get<RequestResponse<TransferStoreEntryDetail[]>>(this._urlBase
            + 'api/TransferEntryStoreDet?transferEntryStoreId=' + transferEntryStoreId);
    }
    
    GetConsigment(storeOriginId,storeDestinationId): Observable<RequestResponse<any>> {
        return this._httpClient.get<RequestResponse<any>>(this._urlBase
            + 'api/TransferStore/Consigment?storeOriginId=' + storeOriginId + '&storeDestinationId=' + storeDestinationId);
    }

    
    GetInvoiceListFile(transferStoreId: number, language: number): Observable<RequestResponse<string>> {
        return this._httpClient.get<RequestResponse<string>>(this._urlBase + 'api/TransferStore/InvoiceListFile?transferStoreId='+transferStoreId+'&language='+language);
    }
}
